/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardEntity,
    CardEntityFromJSON,
    CardEntityFromJSONTyped,
    CardEntityToJSON,
} from './CardEntity';
import {
    CardTypeConsentEntity,
    CardTypeConsentEntityFromJSON,
    CardTypeConsentEntityFromJSONTyped,
    CardTypeConsentEntityToJSON,
} from './CardTypeConsentEntity';

/**
 * 
 * @export
 * @interface PersonEntity
 */
export interface PersonEntity {
    /**
     * 
     * @type {string}
     * @memberof PersonEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonEntity
     */
    personId?: string;
    /**
     * 
     * @type {Array<CardTypeConsentEntity>}
     * @memberof PersonEntity
     */
    cardTypeConsentEntities?: Array<CardTypeConsentEntity>;
    /**
     * 
     * @type {Array<CardEntity>}
     * @memberof PersonEntity
     */
    cardEntities?: Array<CardEntity>;
}

export function PersonEntityFromJSON(json: any): PersonEntity {
    return PersonEntityFromJSONTyped(json, false);
}

export function PersonEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'cardTypeConsentEntities': !exists(json, 'cardTypeConsentEntities') ? undefined : ((json['cardTypeConsentEntities'] as Array<any>).map(CardTypeConsentEntityFromJSON)),
        'cardEntities': !exists(json, 'cardEntities') ? undefined : ((json['cardEntities'] as Array<any>).map(CardEntityFromJSON)),
    };
}

export function PersonEntityToJSON(value?: PersonEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'personId': value.personId,
        'cardTypeConsentEntities': value.cardTypeConsentEntities === undefined ? undefined : ((value.cardTypeConsentEntities as Array<any>).map(CardTypeConsentEntityToJSON)),
        'cardEntities': value.cardEntities === undefined ? undefined : ((value.cardEntities as Array<any>).map(CardEntityToJSON)),
    };
}

